import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { finalSummary, images } from '../data/content';
export function FinalCta() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="final-title" data-id="element-142" data-mp="19fqn3v4lvpeq">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-143" data-mp="15d40q9qpewox">
        <h2 id="final-title" className="font-serif text-[34px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-144" data-mp="1jd535tmmac6i">
          Ready to stop guessing <em className="text-brand-600" data-id="element-145" data-mp="1ed0li09z3bep">where to start?</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-146" data-mp="1t2om0zaby61d">
          Start reviewing your CBCTs with a structured 7-step process. You don’t need another 20-hour course. You
          need to know what to look at, in what order, and what information you need to document before moving into
          implant planning.
        </p>

        <div className="mt-10 grid items-center gap-8 rounded-3xl bg-brand-50 p-5 text-left sm:p-8 md:grid-cols-2" data-id="element-147" data-mp="1x2gocu94rfya">
          <img src={images.mockup} alt="CBCT Decision Map complete package" className="w-full" loading="lazy" data-id="element-148" data-mp="s4pe1ueleodj" />
          <div data-id="element-149" data-mp="x41x042cfbau">
            <p className="font-serif text-2xl font-extrabold text-brand-800" data-id="element-150" data-mp="x3iplhabk5b2">CBCT Decision Map™</p>
            <ul className="mt-4 space-y-3" data-id="element-151" data-mp="12353lsxz1pkx">
              {finalSummary.map(s => <li key={s} className="flex items-center gap-2.5 text-[17px] font-semibold text-ink" data-id="element-152" data-mp="1650630rn290a">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-153" data-mp="1b31pxnww2cct">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-154" data-mp="1fvbbkrqz0q9a" />
                  </span>
                  {s}
                </li>)}
            </ul>
            <p className="mt-6 text-sm font-bold uppercase tracking-wider text-muted" data-id="element-155" data-mp="1pt8wp6dja6xo">Only</p>
            <p className="font-serif text-6xl font-black leading-none text-cta-dark" data-id="element-156" data-mp="1tt9l9jucjyig">
              $27 <span className="font-sans text-lg font-extrabold text-ink" data-id="element-157" data-mp="3qu5o83bfzfmz">USD</span>
            </p>
          </div>
        </div>

        <CtaButton className="mt-10" label="Get instant access for $27" note="Instant digital access · Lifetime access · One-time payment · 7-Day Guarantee" data-id="element-158" data-mp="3lwvqm0dwfxo2" />
        <Countdown label="The special launch offer ends in:" data-id="element-159" data-mp="3uv7nul99ttph" />
      </div>
    </section>;
}